'use client';

import * as React from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';

const Avatar: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({
  className,
  children,
  ...props
}) => (
  <div
    className={cn(
      'bg-color-grey flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

const AvatarIcon: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => (
  <span
    {...props}
    className={cn('text-color-background-base size-4', className || 'icon-emp-avatar')}
  />
);

export { Avatar, AvatarIcon };
